import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ICompany, IGraduates, IVacancies } from '@interfaces/ICompany';

@Injectable({
  providedIn: 'root',
})
export class CompaniesViewService {
  constructor(private _http: HttpClient) {}

  getCompanies(queries?: { [key: string]: string }): Observable<ICompany> {
    const url = `${environment.baseUrl}api/v1/users/companies/`;
    return this._http.get<ICompany>(url, { params: queries });
  }

  getGraduates(queries?: { [key: string]: string }): Observable<IGraduates> {
    const url = `${environment.baseUrl}api/v1/users/graduates/`;
    return this._http.get<IGraduates>(url, { params: queries });
  }

  getVacancies(queries?: { [key: string]: string }): Observable<IVacancies> {
    const url = `${environment.baseUrl}api/v1/vacancies/`;
    return this._http.get<IVacancies>(url, { params: queries });
  }
}
